import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@/AppQueryClient";
import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type {
  PatchUserAdminStatusParams,
  UserWithAuthorizations,
} from "./apiEcms.types";

const patchUserAdminStatus = ({ id, isAdmin }: PatchUserAdminStatusParams) =>
  apiEcmsHttp.patch<UserWithAuthorizations>(`/users/${id}/admin-status`, {
    isAdmin,
  });

export const usePatchUserAdminStatus = () => {
  const { currentGroup } = useGroupReferences();
  const { t } = useCustomTranslation("main");

  return useMutation({
    mutationKey: [QUERY_KEYS.USER_ADMIN_STATUS_EDITION, currentGroup],
    mutationFn: patchUserAdminStatus,
    onSuccess: ({ data: user }) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USER, user.id, currentGroup],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USERS, currentGroup],
      });
      addToast({
        variant: "success",
        title: t("userDetails.role.success"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("userDetails.role.error"),
      });
    },
  });
};
